<template>
  <div>
    <p>
      <h-read-more
        missing-str="No description provided."
        :max-chars="200"
        :text="$attrs.content.description"
      />
    </p>

    <div class="grid-body is-mobile">
      <div class="images">
        <img
          v-if="$attrs.content.screenshots"
          :src="cloud($attrs.content.screenshots[0])"
          :alt="$attrs.content.title"
        />
      </div>

      <div class="content">
        <b-taglist>
          <b-tag v-for="tag in $attrs.content.tags" :key="tag">{{ tag }}</b-tag>
        </b-taglist>
        <div class="level">
          <b-icon size="is-small" icon="clock" />
          <span>{{ $attrs.content.createdAt | long_date }}</span>
        </div>
        <div class="level">
          <b-icon size="is-small" icon="tag" />
          <span>{{ numPlacements }}</span>
        </div>
        <h-developer
          :id="$attrs.content.developerID"
          v-slot="{ dev_link }"
          tag="span"
        >
          <div class="level">
            <b-icon size="is-small" icon="user" />
            <span>
              <component :is="dev_link" />
            </span>
          </div>
        </h-developer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    numPlacements() {
      const numPlacements = this.$attrs.content.placements
        ? this.$attrs.content.placements.length
        : 0;
      const itemText = numPlacements === 1 ? "item" : "items";
      return `${numPlacements} ${itemText}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/bulma_overrides.scss";
@import "@/assets/scss/favorites_portals.scss";

.grid-body .images {
  grid-template-columns: 1fr;
}
</style>
